<template>
  <div>
    <footer id="footer">
      <div class="container">
        <div class="copyright">
          &copy; Copyright <strong><span>Jotweb</span></strong>
        </div>
      </div>
    </footer>
    <!-- End  Footer -->

    <a href="#" class="back-to-top"
      ><i class="icofont icofont-simple-up"></i
    ></a>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
